import React, { useContext } from 'react';
import { PlaceholderWrapper } from '../components/PlaceholderWrapper';
import { RepeatedVirtualSlotsPlaceholderContext } from '../slotsPlaceholderContext';
import { isSlotHighlighted, buildUniqueSlotId } from '../utils';
import { buildSlotPlaceholderDataHook } from '../utils/buildUniqueSlotId';
export const useRepeatedSlotPlaceholder = (slotId) => {
    const repeatedSlotsContext = useContext(RepeatedVirtualSlotsPlaceholderContext);
    if (!repeatedSlotsContext) {
        throw new Error('`useRepeatedSlotPlaceholder` can only be used inside` withRepeatedSlotsPlaceholders` HOC');
    }
    const iSlotHighlighted = isSlotHighlighted(repeatedSlotsContext.slotPreviewState, slotId);
    const slotUniqueId = buildUniqueSlotId(repeatedSlotsContext.hostId, slotId);
    const getRepeatedItem = (repeatedItemId) => {
        if (!repeatedSlotsContext.getSlotByItemId) {
            throw new Error('Function `getSlotByItemId` is not defined');
        }
        const widgetPlugin = repeatedSlotsContext.getSlotByItemId(slotId, repeatedItemId);
        const isEmpty = !widgetPlugin;
        const Placeholder = () => {
            return (React.createElement(PlaceholderWrapper, { slotUniqueId: slotUniqueId, isHighlighted: iSlotHighlighted, isEmpty: isEmpty, dataHook: buildSlotPlaceholderDataHook(slotUniqueId, repeatedItemId), PluginComponent: () => widgetPlugin }));
        };
        return [
            Placeholder,
            {
                id: repeatedItemId,
                isEmpty,
            },
        ];
    };
    return { getRepeatedItem };
};
//# sourceMappingURL=useRepeatedSlotPlaceholder.js.map